<template>
  <div class="productList">
    <div class="list-box">
      <myScroll style="width:100%;height:100%">
        <el-table :data="list"
                  :header-cell-style="{background:'#efeff5',padding: '6px 0'}"
                  :border="false"
                  @selection-change="changeSelect"
                  ref="tableLayer"
                  @row-click="handleRowClick">
          <el-table-column type="selection"
                           header-align="center"
                           width="45">
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <el-input size="mini"
                        v-model="search"
                        clearable
                        @change="searchProduct"
                        prefix-icon="el-icon-search"
                        :placeholder="$t('model.Search')"
                        class="search"></el-input>
            </template>
            <template slot-scope="scope">
              <div class="color-cube"
                   :style="{backgroundColor:scope.row.color }"></div>
              <div class="name">{{scope.row.id}}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="buttonDiv">
          <el-tooltip :content="tooltipContent"
                      placement="bottom">
            <div style="width:100%">
              <el-button type="primary"
                         :disabled="checkList.length<=0"
                         v-has="'Add Task'"
                         @click="openProductTaskDialog"
                         circle
                         icon="el-icon-plus">
              </el-button>
            </div>
          </el-tooltip>
        </div>
      </myScroll>
    </div>
    <add-task-dialog :showDialog="productDialogShow"
                     @closeDialog="closeAddTaskDialog"></add-task-dialog>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import AddTaskDialog from './layout/addProductTask'
import _ from 'lodash'

export default {
  data () {
    return {
      checkList: [],
      list: [],
      search: ''
    }
  },
  computed: {
    tooltipContent () {
      return this.checkList.length <= 0 ? this.$t('model.PleaseSelectProduct') : this.$t('model.Addmultipletasksfromproducts')
    },
    productList () {
      return this.$store.state.diag.data.productList
    },
    productDialogShow () {
      return this.$store.state.diag.params.productDialog.showDialog
    }
  },
  created () {
  },
  mounted () {
    this.list = this.productList
  },
  watch: {
    productList (to, from) {
      this.list = to
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      this.$refs.tableLayer.toggleRowSelection(row)
    },
    changeSelect (val) {
      this.$store.commit('diag/clearAddProductList')
      this.checkList = val
      let arr = _.cloneDeep(val)
      arr.forEach(res => {
        this.$store.commit('diag/setAddProductList', res)
      })
    },
    openProductTaskDialog () {
      this.$store.commit('diag/openProductTaskDialog', true)
    },
    closeAddTaskDialog (id) {
      this.$store.commit('diag/clearAddProductList')
      this.$store.commit('diag/openProductTaskDialog', false)
      this.$refs.tableLayer.clearSelection()
      if (id) {
        this.$store.dispatch('diag/getTasksList')
      }
    },
    searchProduct () {
      if (this.search) {
        let list = _.cloneDeep(this.productList)
        let string = RegExp(this.search, 'i')
        this.list = []
        for (let i of list) {
          if (i.id.search(string) >= 0) {
            this.list.push(i)
          }
        }
      } else {
        this.list = this.productList
      }
    }
  },
  components: {
    AddTaskDialog
  }
}
</script>

<style scoped lang="scss">
.productList {
  height: 100%;
  height: 100%;
  .header {
    height: 38px;
    overflow: hidden;
    background-color: #fff;
    padding: 0 10px;
    line-height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdfe6;
    .title {
      flex-grow: 15;
    }
    .el-button {
      flex-grow: 1;
    }
    .add {
      font-size: 22px;
    }
  }
  .list-box {
    width: 100%;
    height: calc(100% - 2px);
    position: relative;
    .color-cube {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      float: left;
    }
    .name {
      line-height: 40px;
      font-size: 14px;
      height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .buttonDiv {
    bottom: 80px;
    position: fixed;
    right: 40px;
    z-index: 999;
    .el-button {
      font-size: 30px;
    }
  }
}
</style>
